import { Injectable, inject } from '@angular/core';
import { AssistantAction } from '../../../core/services/voice-actions/models';
import { readActionPayloadValue } from '../../../core/services/voice-actions/voice-action-payload';
import { SocialPostVoiceActionService } from '../../Social/services/social-post-voice-action.service';
import { SmartVideoVoiceActionService } from '../../VideoGen/services/smart-video-voice-action.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardTrendVoiceActionService {
  private readonly smartVideoActions = inject(SmartVideoVoiceActionService);
  private readonly socialPostActions = inject(SocialPostVoiceActionService);

  async openTrendCreate(action: AssistantAction): Promise<void> {
    const trendQuery = readActionPayloadValue<string>(action, 'trendQuery')
      || readActionPayloadValue<string>(action, 'topic')
      || readActionPayloadValue<string>(action, 'title')
      || readActionPayloadValue<string>(action, 'inputData');
    const target = this.normalizeTrendTarget(readActionPayloadValue<string>(action, 'target'));
    const trendAction: AssistantAction = {
      ...action,
      payload: {
        ...action.payload,
        source: 'trend-radar',
        ...(trendQuery ? { inputData: trendQuery, topic: trendQuery } : {}),
      },
    };

    if (target === 'social-post') {
      await this.socialPostActions.openCreate(trendAction);
      return;
    }

    await this.smartVideoActions.openCreate(trendAction);
  }

  private normalizeTrendTarget(value: string | undefined): 'smart-video' | 'social-post' | undefined {
    const normalized = value?.trim().toLowerCase();
    if (!normalized) return undefined;
    if (normalized.includes('post') || normalized.includes('social')) return 'social-post';
    if (normalized.includes('video') || normalized.includes('smart')) return 'smart-video';
    return undefined;
  }

}
